/// <field name='lc' type='Object'>Labour charges object</field>
window.stock = cafm.stock = {
    partsSelector: '#viewParts',
    get partListSelector() { return '#' + cafm.res.consts.ElementId_PartList },
    changedHandlerName: 'cafm.stock.onStockChanged',
    init: function () {
        /// <summary>Stock initialiser</summary>

        var pv = $(stock.partsSelector);
        stock.partsView = pv;
    },
    dataRetrieved: function (d) {
        /// <summary>Handler for when labour charge list data has been retrieved</summary>
        /// <param name="d" type="Array">Array of labour charge data</param>

        stock.partList = $(stock.partListSelector);
    },
    dataBound: function() {

        stock.partList.find('.partQuantity').kendoNumericTextBox({

            decimals: 0,
            format: 'n0',
            spinners: false,
            change: stock.partQuantityChange
        });
    },
    onPartLookupPreFetch: function(c){

        if (c.PartGroupCodeId.value) {

            c.PartGroupCodeId = c.PartGroupCodeId.value;
        }
    },    
    partLookupSelected: function(e){

        var vp = stock.partsView;
        var id = cafm.util.stringToArray(e.val);
        var existingParts = stock.partList.getLv().dataSource.data();

        // convert to json array to avoid picking up other objects
        if (existingParts && existingParts.toJSON()) {

            existingParts = existingParts.toJSON();
        }

        // filter out existing parts
        cafm.util.removeWhere(id, function (theId) {

            return cafm.util.exists(existingParts, function (part) {

                return theId == part.PartDefinitionId;
            });
        });

        var pids = [];
        id.forEach(function (i) {
            if (i != cafm.guid.empty) {
                pids.push({
                    IDs: cafm.util.createParentChildId(cafm.hd.workOrder.get('ID'), i)
                });
            }
        });

        if (pids.length) {
            
            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/AddParts'),
                description: cafm.res.str.TextRemovePart,
                values: pids,
                elementId: 'viewParts',
                loaderSelector: '#viewParts',
                preventValidate: true,
                statusCodeFuncs: {
                    200: function (r) {

                        cafm.handlers.exe(stock.changedHandlerName, r);
                        stock.refreshPartList();
                        $('#partLookup').clearLookup({ suppressEvents: true, timeout: 500 });
                        $('#viewParts').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessagePartAdded });
                    }
                }
            });
        }
    },
    partQuantityChange: function (e) {

        var q = e.sender.value();

        if (cafm.util.isNum(q)) {

            var item = e.sender.wrapper.parents('.cLvIt:first');
            var part = stock.partList.getLv().dataSource.getByUid(item.data('uid'));
            
            if (part.ID) {

                cafm.actions.execute({

                    url: cafm.url.api('WorkOrder/UpdatePartQuantity'),
                    elementId: 'viewParts',
                    loaderSelector: '#viewParts',
                    loaderText: cafm.res.str.MessageUpdatingPartQuantity,
                    values: {
                        IDs: cafm.util.createParentChildId(cafm.hd.workOrder.get('ID'), part.ID),
                        ActualQuantity: q,
                        EstimatedQuantity: q
                    },
                    statusCodeFuncs: {

                        200: function (r, s) {

                            cafm.handlers.exe(stock.changedHandlerName, r);
                            stock.refreshPartList();

                            if (r.StockShortfallMessage) {

                                stock.partsView.showMessage({

                                    Type: cafm.enums.MessageType.Warning,
                                    Title: r.StockShortfallMessage
                                });
                            }
                            else {

                                stock.partsView.showMessage({

                                    Type: cafm.enums.MessageType.Success,
                                    Title: cafm.res.str.MessageUpdatedPartQuantity
                                });
                            }
                        }
                    }
                });
            }
        }
    },
    /// <field name='listToolbar' type='Object'>Labour charges list toolbar</field>
    partsToolbar: {

        add: function () {

            cafm.lookup.open('partLookup');
        },
        remove: function (e) {
            /// <summary>Delete handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            var ids = $(e.target).getListSelectedParentChildArray({ parentId: cafm.hd.workOrder.get('ID') });
            if (!ids) {
                return;
            }

            if (ids.length) {

                cafm.actions.execute({
                    url: cafm.url.api('WorkOrder/RemoveParts'),
                    description: cafm.res.str.TextRemovePart,
                    values: ids,
                    elementId: 'viewParts',
                    loaderSelector: '#viewParts',
                    preventValidate: true,
                    statusCodeFuncs: {
                        200: function (r) {

                            cafm.handlers.exe(cafm.stock.changedHandlerName, r);
                            stock.refreshPartList();
                            $('#viewParts').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageItemsDeleted });
                        }
                    }
                });
            }
        }
    },
    refreshPartList: function () {

        cafm.util.refreshList({
            listSelector: stock.partListSelector,
            key: cafm.res.consts.DataKey_HelpdeskStock
        });
    },
    enablePermissibleFeatures: function (p) {

        var vp = $('#viewParts'),
            lh = $('.cLvHead', vp),
            sl = $(stock.partListSelector);

        //if (isMobile) {

            if (p.add || p.remove) {

                lh.show();
            }
            else {

                lh.hide();
            }
        //}
        if (p.add) {

            $('#partLookupContainer', vp).show();
            $('[data-key="Add"]', lh).show();
        }
        if (!p.remove) {

            sl.disableListItemRemoving();
        }

        if (!p.edit) {

            sl.find('.partQuantity').prop('disabled', 'true');
        }
    },
    getWorkOrderParts: function () {

        return cafm.hd.getWorkOrderChildList('Parts');
    }
}